import React, { useEffect, useRef, useState } from 'react'
import Header from '../../common/HeaderAfterLogin'
import { getData } from "../../Service/ApiMethod";
import { CREDIT_VALUE,Credit_BALANCE } from "../../Service/service";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { Modal, Button } from 'react-bootstrap';
import CheckoutForm from "../subcription/CheckoutForm";
import { lang } from '../../lang';

// import CheckoutForm from "./CheckoutForm";
const promise = loadStripe("pk_live_51NFrUvCibbZW6HqQh8TWqaUzdPwgmwoUv6noqe0ef1UbbCX0CPgfSUKkpTyawnNnGFNpvnyAeiS64GrZG1R4yfi000KUXj8uc8");
export default function Searchscreen() {
  const [ln,setLn] = useState('en')
  const [creditAmount,setCreditValue]= useState(0)
  const [enterAmount, setAmount] = useState(0)
  const [reDate, setResData] = useState([])
  const [show, setShow] = useState(false);
  const [clientSecrets, setClientSecret] = useState("");
  const clientSecretss = useRef("")
  const handleClose = () => setShow(false);
  const handleShow = () => {
    // const currentUrl = window.location.href
    console.log(creditAmount, "58888888")
      checkValss()
    setTimeout(()=>{
      setShow(true)
    },2000)
    
    
  };

  const profile_Status = () => {
    getData(CREDIT_VALUE)
      .then((response) => response.json())
      .then((res) => {
        console.log("okkkkkkkk",res);
        setCreditValue(res.data.credit_value)
      })
      .catch((err) => {
        console.log("profileStatusErr", err);
      });
  };
  useEffect(()=>{
    if(localStorage.getItem("language") != null){
      setLn(localStorage.getItem("language"))
    }
  },[])
  useEffect(() => {
    profile_Status()
    getDetail()
  }, [])

  const getDetail = () => {
    getData(Credit_BALANCE)
      .then((response) => response.json())
      .then((res) => {
        console.log("Sssssssss",res.data.credit_balance_history[0]);
        setResData(res.data.credit_balance_history[0])
      })
      .catch((err) => {
        console.log("Error ", err);
      });
  };



  const checkValss = () => {
    let obj = {
      serviceId: 1,
      subscription_id: reDate.plan_id,
      txnAmount: (creditAmount*enterAmount) * 100,
      gateWayName: "card",
      paymentMode: 1,
      user_type: "RECRUITER"
    };
    window.fetch("https://api.catzapp.com/manage_plan_txn/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("catzapp_token"),
      },
      body: JSON.stringify(obj),
    }).then((res) => {
      return res.json();
    }).then((data) => {
      console.log("sdeee", data.data.payment_intent.client_secret);
      clientSecretss.current = data.data.payment_intent.client_secret
      setClientSecret(data.data.payment_intent.client_secret);
    });
  }

  return (
    <>
      <Header />
      <div className='credit-outerr' style={{
    }}>
       <div className='credit-innerr' style={{}}>
        <div>
          <h4 style={{margin:10,marginLeft:-5}}>{lang && Object.keys(lang).length > 0 ? lang[ln]?.CreditHistory["Credit Top-up"]:""}</h4>
          <p style={{    fontWeight: "500",
    fontSize: 14,
    letterSpacing: -0.408,
    color: "#444444"}}>{lang && Object.keys(lang).length > 0 ? lang[ln]?.CreditHistory["Per Credit Amount"]:""}</p>
          <input placeholder='Per Credit Amount'value={creditAmount} disabled={true} style={{background: "#ffffff",
    border: "1px solid #d2d2d2",
    borderRadius: 3,
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 0,
    padding: 5,
    letterSpacing: -0.408,
    color: "#96989",
    width: "100%"}}/>
        </div>
        <div>
          <p style={{    fontWeight: "500",
    fontSize: 14,
    letterSpacing: -0.408,
    color: "#444444"}}>{lang && Object.keys(lang).length > 0 ? lang[ln]?.CreditHistory["Enter No. Credits"]:""}</p>
          <input placeholder='Enter No. Credits'value={enterAmount} onChange={(e)=> setAmount(e.target.value)} style={{background: "#ffffff",
    border: "1px solid #d2d2d2",
    borderRadius: 3,
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 0,
    padding: 10,
    letterSpacing: -0.408,
    color: "#96989",
    width: "100%"}}/>
        </div>
        <div>
          <p style={{    fontWeight: "500",
    fontSize: 14,
    letterSpacing: -0.408,
    color: "#444444"}}>{lang && Object.keys(lang).length > 0 ? lang[ln]?.CreditHistory["Total Amount"]:""}</p>
          <input placeholder='Total Amount' value={creditAmount*enterAmount} disabled={true} style={{background: "#ffffff",
    border: "1px solid #d2d2d2",
    borderRadius: 3,
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 0,
    padding: 10,
    letterSpacing: -0.408,
    color: "#96989",
    width: "100%"}}/>
        </div>
        <br></br>
        <button onClick={()=>{
          if(enterAmount != 0){
          handleShow()
          }else{
            alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["Please Enter Credit Point"]:"")
          }
          }}>{lang && Object.keys(lang).length > 0 ? lang[ln]?.Hiring["Submit"]:""}</button>
       </div>
       <Modal className='cardDetailModal' show={show} onHide={handleClose} style={{  }}>
              <Modal.Header closeButton>
                <h5>Enter Card Details</h5>
              </Modal.Header>
              <Modal.Body>
                <div className="App">
                  <Elements stripe={promise}>
                    <CheckoutForm clientSecretss={clientSecretss.current} checkVal={() => { console.log(false) }}/>
                  </Elements>
                </div>
              </Modal.Body>
            </Modal>
      </div>
    </>

  )
}
